import { generateLoginLink } from "@/api/apis";
import { Button } from "@/v2-components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/v2-components/ui/dialog";
import { useRouter } from "next/navigation";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  description?: React.ReactNode;
}

export function LoginDialog({ open, onOpenChange, description }: Props) {
  const router = useRouter();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex min-h-[200px] max-w-[390px] flex-col p-6">
        <DialogHeader>
          <DialogTitle>Log in Required</DialogTitle>
          <DialogClose />
        </DialogHeader>
        <DialogDescription className="sr-only flex-1"></DialogDescription>
        {description && (
          <div className="flex flex-col gap-4 text-base">{description}</div>
        )}

        <DialogFooter className="w-full items-center justify-end gap-2">
          <DialogClose asChild>
            <Button
              size="sm"
              variant="blue-outline"
              shape="pill"
              className="px-7"
            >
              Close
            </Button>
          </DialogClose>
          <Button
            size="sm"
            variant="blue-fill"
            shape="pill"
            className="px-7"
            onClick={() => {
              router.push(generateLoginLink(window.location.href));
              onOpenChange(false);
            }}
          >
            Log-in
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
